import { render, staticRenderFns } from "./chain-output.vue?vue&type=template&id=5ec23436&scoped=true"
import script from "./chain-output.vue?vue&type=script&lang=js"
export * from "./chain-output.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec23436",
  null
  
)

export default component.exports